import styles from './view-toggle.module.scss'

export type CalendarView = 'week' | 'month'

type Props = {
  value: CalendarView
  onChange: (next: CalendarView) => void
}

export function ViewToggle({ value, onChange }: Props) {
  return (
    <div className={styles.toggle} role="group" aria-label="Calendar view">
      <button
        type="button"
        className={`${styles.option} ${value === 'week' ? styles.active : ''}`}
        aria-pressed={value === 'week'}
        onClick={() => onChange('week')}
      >
        Week
      </button>
      <button
        type="button"
        className={`${styles.option} ${value === 'month' ? styles.active : ''}`}
        aria-pressed={value === 'month'}
        onClick={() => onChange('month')}
      >
        Month
      </button>
    </div>
  )
}
